import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';

export const teamMemberSchema = z.object({
  member: z.string().min(1, 'Select member is required'),
});

const AddTeamMemberDialog = ({ isOpen, onClose, onSubmit, users = [] }) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    clearErrors,
    reset,
  } = useForm({
    resolver: zodResolver(teamMemberSchema),
    values: { member: '' },
  });

  const handleClose = () => {
    clearErrors('member');
    reset({ member: '' });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} >
      <DialogTitle>Add Member to Team</DialogTitle>
      <DialogContent sx={{ width: 350 }}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12}>
              <Controller
                name="member"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Select member"
                    variant="outlined"
                    fullWidth
                    error={!!errors.member}
                    helperText={errors.member ? errors.member.message : ''}>
                    {users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.full_name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                }}>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  variant="outlined">
                  Cancel
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  Add Member
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddTeamMemberDialog;
